import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";

interface UseAddCommentParams {
	onSuccess?: (returnRequest: ReturnRequestDto) => void;
}

export default function useAddComment(params: UseAddCommentParams) {
	return $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/comments",
		{
			onSuccess(data) {
				params.onSuccess?.(data);
			},
			onError(error) {
				console.error(error);
			},
		},
	);
}
